import { logClientError } from 'src/util/server-log';
import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { bootstrapApplication } from "@angular/platform-browser";
import { EnvironmentType } from "@models/env";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
import "./polyfills";



registerLocaleData(localePt);

bootstrapApplication(AppComponent, appConfig).catch((err) => logClientError(err));

export const endpointBase =
  environment.env === EnvironmentType.development ? "" : environment.env === EnvironmentType.homolog ? "" : "";

export const endpointBaseGRPC =
  environment.env === EnvironmentType.development
    ? "https://grpcweb.svm.development.supermup.com.br"
    : environment.env === EnvironmentType.homolog
      ? "https://grpcweb.svm.homolog.supermup.com.br"
      : "https://grpcweb.mare.svm.com.br";

export const applicationClientId =
  environment.env === EnvironmentType.development ? "" : environment.env === EnvironmentType.homolog ? "" : "";